import React, {Fragment, useMemo} from "react";
import PropTypes from "prop-types";
import {CardBody, Col, Row} from "reactstrap";
import ThemedClampLines from "../../../shared/components/clamp-lines/ThemedClampLines";
import {CountryBadgeList} from "../../../shared/components/badge/BadgeLists";
import TargetVictimMaps from "../../../shared/components/maps/EasyVectorMap/TargetVictimMaps";
import ActorCountryBadge from "../../../shared/components/badge/ActorCountryBadge";
import ContentCardFooter from "../../../shared/components/card/accessories/ContentCardFooter";
import IndicatorsTypeTab from "../../../shared/components/tab/IndicatorsTypeTab";
import {getCommonTags} from "../../../shared/helpers";
import {getCountryNameOrCodeShort} from "../../../shared/helpers/country-data";


const ContentBody = ({content, types, isOpen, updateFilters = () => {}}) => {
  const commonTags = useMemo(() => getCommonTags(content.tags), [content.tags]);

  return (
    <CardBody>
      <Row>
        <Col md={4} xs={12}>
          <p>
            <ThemedClampLines
              text={content.text}
              lines={6}
              maxLines={12}
            />
          </p>
        </Col>
        <Col md={8} xs={12}>
          <Row>
            <Col md={12}>
              <p className="bold-text">Targeted countries</p>
            </Col>
          </Row>
          <Row>
            <Col md={4} className={'mb-3'}>
              {
                content.targeted_countries.length > 0 ?
                  <CountryBadgeList updateFilters={(display, item) => {
                    updateFilters(getCountryNameOrCodeShort(item), 'targeted_countries');
                  }} countries={content.targeted_countries}/> :
                  <h5>NO TARGETED COUNTRIES</h5>
              }
              {
                content.actors && content.actors.length > 0 && <Fragment>
                  <Col md={12} className={'p-0 mt-2'}>
                    <p className="bold-text">Actors origin country</p>
                  </Col>
                  <Col md={12}  className={'p-0'}>
                    {content.actors.map((actor) => <ActorCountryBadge actorUid={actor.uid}/>)}
                  </Col>
                </Fragment>
              }
            </Col>
            <Col md={8}>
              <TargetVictimMaps
                countryCodes={content.targeted_countries}
                idMap={content.uid}
                height={'24vh'}
                withZoomButton={false}
              />
            </Col>
          </Row>
        </Col>
        <Col md={12} xs={12}>
          {isOpen && <IndicatorsTypeTab types={types} contentUid={content.uid} />}
          <ContentCardFooter tags={commonTags} tlp={content.tlp.tlp}/>
        </Col>
      </Row>
    </CardBody>
  )
}

ContentBody.propTypes = {
  content: PropTypes.shape().isRequired,
  types: PropTypes.array.isRequired,
  isOpen: PropTypes.bool.isRequired,
  updateFilters: PropTypes.func
}

export default ContentBody;